import { render, staticRenderFns } from "./PassengerupdateRight.vue?vue&type=template&id=210c4722&scoped=true"
import script from "./PassengerupdateRight.vue?vue&type=script&lang=js"
export * from "./PassengerupdateRight.vue?vue&type=script&lang=js"
import style0 from "./PassengerupdateRight.vue?vue&type=style&index=0&id=210c4722&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "210c4722",
  null
  
)

export default component.exports